/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const PipelinesPromotionIcon = styled.img({
  margin: '12px auto 22px auto',
  display: 'block',
  height: '100px',
});

export const PipelinesPromotionRow = styled.p({
  marginBottom: token('space.100'),
  textAlign: 'left',
  padding: `0 ${token('space.050')}`,
});

export const PipelinesPromotionLink = styled.p({
  marginTop: token('space.200'),
  textAlign: 'center',
  borderTop: `1px solid ${token('color.border')}`,
  padding: token('space.100'),
});
